<template>
  <div v-loading="loading">
    <div class="card-tabs">
      <div @click="cardClick(1)" :class="{'card-active':cardSwitch===1}">行政处罚</div>
      <div @click="cardClick(2)" :class="{'card-active':cardSwitch===2}">行政裁决</div>
    </div>
    <div class="card-wrap">
      <template v-if="tableData.length>0">
        <puishmentList
          v-for="(item, index) in tableData"
          :key="index"
          :data="item"
          :type="activeName"
        ></puishmentList>
        <div v-if="tableData.length===5" class="lookMore" @click="lookMore">查看更多&gt;</div>
      </template>
      <template v-else>
        <div class="card-empty">暂无数据</div>
      </template>
    </div>
  </div>
</template>

<script>
import utils from "@mixins/utils";
import puishmentList from "../section/puishment-list.vue";

export default {
  mixins: [utils],
  components: {
    puishmentList
  },
  data() {
    return {
      loading: false,
      tableData: [], //标准规范
      pgData: {
        type: "xzcf",
        pageIndex: 1,
        pageSize: 5,
        title: "",
        unit: "",
        startcfdate: "",
        endcfdate: "",
        ispunish: "",
      },
      cardSwitch: 1,
      activeName: 'first'
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    cardClick(type) {
      this.cardSwitch = type;
      if (type === 1) {
        this.pgData.type = "xzcf";
        this.activeName = "first";
      }
      if (type === 2) {
        this.pgData.type = "xzcj";
        this.activeName = "second";
      }
      this.getData();
    },
    getData() {
      this.loading = true
      this.$ajax({
        url: `${this.$store.state.api.webUrl}/punishment/getpunishmentpage.json`,
        data: this.pgData,
        callback: data => {
          this.tableData = data.rows
        },
        complete: () => {
          this.loading = false;
        }
      });
    },
    lookMore() {
      window.location.assign("/punishmentCase?activeName=" + this.activeName);
    },
  },
};
</script>

<style scoped lang="scss">
.card-tabs {
  display: flex;
  position: absolute;
  right: -25px;
  top: -66px;

  div {
    margin-right: 24px;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    cursor: pointer;
  }

  .card-active {
    color: #3D7EFF;
    font-weight: bold;
  }
}

.card-wrap {
  border-radius: 8px;
  height: 360px;
}

.card-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #aaa;
  text-align: center;
  padding-top: 20px;
}

.lookMore {
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
</style>

